import { stringifyQuery } from './stringifyQuery';

export const FilterRoutes = {
  conference: '/public/rdb/v1/filters/conferences',
  interest: '/public/rdb/v1/filters/interest',
  sport: '/public/rdb/v1/filters/sports',
  state: '/rdb/v1/states',
  year: '/public/rdb/v1/filters/years',
  position: '/public/rdb/v1/filters/positions',
} as const;

export const RDBRoutes = {
  personSportRankings: '/public/rdb/v1/person-sport-rankings',
  teamRankings(
    _strings?: TemplateStringsArray,
    sportParam?: string | string[],
    yearParam?: string | string[] | number,
    rankingTypeQueryParam?: string | string[],
  ) {
    const sport = stringifyQuery(sportParam);
    const year = stringifyQuery(yearParam);
    const rankingTypeQuery = stringifyQuery(rankingTypeQueryParam);

    return `/public/rdb/v1/team-ranking/${sport}-${year}/${rankingTypeQuery}` as const;
  },
} as const;
type ValueOf<T> = T[keyof T];
export type RouteName = string &
  (ValueOf<typeof RDBRoutes> | ValueOf<typeof FilterRoutes>);
